import React from 'react';
import { styled } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import { Colors } from 'library';
import { RIconTitle } from './RIconTitle';

interface RFormCardProps {
    title?: string;
    icon?: SvgIconComponent;
    children: React.ReactNode;
    headerButton?: React.ReactNode;
}

export function RFormCard({ title, icon, children, headerButton }: RFormCardProps) {
    return (
        <Card>
            {title && (
                <TitleRow>
                    <RIconTitle icon={icon}>{title}</RIconTitle>
                    {headerButton && <HeaderButtonWrapper>{headerButton}</HeaderButtonWrapper>}
                </TitleRow>
            )}
            {children}
        </Card>
    );
}

const Card = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    padding: '28px 32px',
    backgroundColor: Colors.white,
    marginBottom: 16,
});

const TitleRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
});

const HeaderButtonWrapper = styled('div')({
    marginLeft: 'auto',
});
